export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'My reservations',
        route: 'home',
        icon: 'HomeIcon',
      },
    ],
  },
]
